import { IStringContext, StringContext, defaultValues } from "./StringContext";
import { SettingsContext, SettingsInterface } from "./settingsContext";

import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { useEffect, useState } from "react";
import { RichTextContextProvider, resolveUrl } from "@bn-monorepo/js-packages";

interface Props {
  settings: SettingsInterface;
  children: any;
}

const SettingsProvider = (props: Props) => {
  const { settings: settingsProp, children } = props;
  const refreshSettings = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch(`${settings.apiBaseUrl}/settings?v=2&path=${window.location.pathname}`)
      .then((response) => {
        return response.json();
      })
      .then((settings) => {
        settings.refreshSettings = refreshSettings;
        setSettings(settings);
      });
  };

  if (settingsProp) {
    settingsProp.refreshSettings = refreshSettings;
  }

  useEffect(() => {
    window.addEventListener("REFRESH_SETTINGS", refreshSettings);
  }, []);

  const [settings, setSettings] = useState(settingsProp);

  settings.resolveUrl = resolveUrl;

  const mergedStrings = {
    ...defaultValues,
    ...settings.localization,
  } as IStringContext;

  return (
    <StringContext.Provider value={mergedStrings}>
      <ErrorBoundary errorMesage={mergedStrings.index_errorboundary_message}>
        <SettingsContext.Provider value={settings}>
          <RichTextContextProvider
            richTextContext={{
              env: settings.env,
              mediaUrl: settings.mediaUrl,
              useCloudinary: settings.useCloudinary,
              resolveUrl: settings.resolveUrl,
            }}
          >
            {children}
          </RichTextContextProvider>
        </SettingsContext.Provider>
      </ErrorBoundary>
    </StringContext.Provider>
  );
};

export default SettingsProvider;
